import React from "react";
import { Button, Modal } from "react-bootstrap";
import CommonTable from "../../components/tables/CommonTable";

const ChooseAccessProfile = ({
  show,
  setShow,
  currentlyChosenId,
  onChoose,
  children,
}) => {
  const columns = [
    {
      Header: "Profile Name",
      accessor: "permissionName",
      type: "link",
      link: "/accessprofiles/edit",
      stateId: "id",
    },
    {
      Header: "Users",
      accessor: "userCount",
      disableSortBy: true,
    },
    {
      Header: "Assets",
      accessor: "assetCount",
      disableSortBy: true,
      Cell: (cell) => (
        <span>{cell.row.original.allAssets ? "All" : cell.value}</span>
      ),
    },
    {
      Header: "People",
      accessor: "personCount",
      disableSortBy: true,
      Cell: (cell) => (
        <span>{cell.row.original.allPeople ? "All" : cell.value}</span>
      ),
    },
    {
      Header: "Zones",
      accessor: "zoneCount",
      disableSortBy: true,
      Cell: (cell) => (
        <span>{cell.row.original.allZones ? "All" : cell.value}</span>
      ),
    },
    {
      Header: "Action",
      accessor: "id",
      disableSortBy: true,
      Cell: (cell) =>
        currentlyChosenId && currentlyChosenId === cell.value ? (
          <React.Fragment></React.Fragment>
        ) : (
          <Button
            onClick={() => {
              onChoose && onChoose(cell.row.original);
            }}
            variant={"primary"}
          >
            Choose
          </Button>
        ),
    },
  ];

  return (
    <React.Fragment>
      <Modal size={"xl"} show={show} onHide={() => setShow(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Choose Access</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <CommonTable apiName="accessprofiles" columns={columns} />
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};

export default ChooseAccessProfile;
